import { createSlice } from "@reduxjs/toolkit";
import {
  getCashHandovers,
  confirmCashHandover,
  getCashHandoversSummary,
} from "./cashHandoversActions";

const initialState = {
  list: {
    items: [],
    meta: null,
    loading: false,
    error: null,
  },
  confirm: {
    id: null,
    loading: false,
    error: null,
  },
  summary: {
    data: null,
    loading: false,
    error: null,
  },
};

const cashHandoversSlice = createSlice({
  name: "cashHandovers",
  initialState,
  reducers: {
    resetConfirmError: (state) => {
      state.confirm.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCashHandovers.pending, (state) => {
        state.list.loading = true;
        state.list.error = null;
      })
      .addCase(getCashHandovers.fulfilled, (state, action) => {
        state.list.loading = false;
        state.list.items = action.payload?.results || [];
        state.list.meta = action.payload?.meta || null;
        state.list.error = null;
      })
      .addCase(getCashHandovers.rejected, (state, action) => {
        state.list.loading = false;
        state.list.error = action.payload;
      })
      .addCase(getCashHandoversSummary.pending, (state) => {
        state.summary.loading = true;
        state.summary.error = null;
      })
      .addCase(getCashHandoversSummary.fulfilled, (state, action) => {
        state.summary.loading = false;
        // Only a JSON object counts; anything else (e.g. an HTML page from a
        // backend that does not have the endpoint yet) means no totals.
        const payload = action.payload;
        state.summary.data =
          payload && typeof payload === "object" && !Array.isArray(payload)
            ? payload
            : null;
        state.summary.error = null;
      })
      .addCase(getCashHandoversSummary.rejected, (state, action) => {
        state.summary.loading = false;
        state.summary.error = action.payload;
      })
      .addCase(confirmCashHandover.pending, (state, action) => {
        state.confirm.id = action.meta.arg?.id ?? null;
        state.confirm.loading = true;
        state.confirm.error = null;
      })
      .addCase(confirmCashHandover.fulfilled, (state, action) => {
        state.confirm.id = null;
        state.confirm.loading = false;
        state.list.items = state.list.items.map((row) =>
          row?.id === action.payload?.id ? { ...row, ...action.payload } : row
        );
      })
      .addCase(confirmCashHandover.rejected, (state, action) => {
        state.confirm.id = null;
        state.confirm.loading = false;
        state.confirm.error = action.payload;
        // 409 returns the handover someone else confirmed or canceled first:
        // show that row without another GET.
        const stored = action.payload?.status === 409 ? action.payload?.handover : null;
        if (stored?.id) {
          state.list.items = state.list.items.map((row) =>
            row?.id === stored.id ? { ...row, ...stored } : row
          );
        }
      });
  },
});

export const { resetConfirmError } = cashHandoversSlice.actions;
export default cashHandoversSlice.reducer;
